import PartyCharacter from "../character/PartyCharacter";
import GameTime from "../time/GameTime";
import SkillActivationTracker from "./SkillActivationTracker";
import SkillType from "./SkillType";

export default class SkillGroup {
    /**
     * 
     * @param {GameTime} gameTime
     * @param {SkillType} skillType 
     * @param {number} groupOffset
     */
    constructor(gameTime, skillType, groupOffset) {
        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;
        /**
         * @constant
         * @type {SkillType}
         */
        this.skillType = skillType;
        /**
         * @constant
         * @type {PartyCharacter}
         */
        this.miners = [];

        /**
         * @constant
         * @type {SkillActivationTracker}
         */
        this.skillActivationTracker = new SkillActivationTracker(groupOffset, skillType.durationUpgrades, skillType.coolDownUpgrades);
    }

    /**
     * @param {PartyCharacter} miner 
     */
    addMiner(miner) {
        this.miners.push(miner);

        // The activation tracker needs to know how many miners there are.
        this.skillActivationTracker.setMinerCount(this.gameTime.turnNumber, this.miners.length);
    }

    /**
     * @param {number} turnNumber
     */
    updateSkillsForTurn(turnNumber) {
        this.skillActivationTracker.updateForTurn(turnNumber);
    }

    /**
     * @param {number} frameTimeRatio 
     */
    updateSkillsForFrame(frameTimeRatio) {
        for (let i = 0; i < this.miners.length; i++) {
            this.skillType.updateSkillForFrame(this.miners[i], frameTimeRatio, this.skillActivationTracker.isSkillActive(i));
        }
    }

    resetForPrestige() {
        this.skillActivationTracker.resetForPrestige();
    }
}